var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"prt-autocomplete-bubble",attrs:{"aria-label":_vm.$slots.default[0].text}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }